// extracted by mini-css-extract-plugin
export default {"page":"AuthLayout_page__dRHxh","logoWrapper":"AuthLayout_logoWrapper__PCZlx","card":"AuthLayout_card__qA+A1","title":"AuthLayout_title__TGcqp"};